import { Rule } from 'antd/lib/form';
import FormSelect from 'components/Select/FormSelect';
import { ISelectOption } from 'components/Select/types';
import React, { useMemo } from 'react';
import { TDropboxPushMessage } from 'types';
import { dropboxPushMessages } from 'appConstants';
import { useTranslation } from 'react-i18next';

interface IMessageSelect {
	setDropboxPushMessage: (value: TDropboxPushMessage | null) => void;
}

const MessageSelect: React.FC<IMessageSelect> = ({ setDropboxPushMessage }) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('selectMessage') }], [t]);

	const mappedData = useMemo<ISelectOption[]>(() => {
		return dropboxPushMessages.map((el) => ({ id: el.value, name: el.name }));
	}, [dropboxPushMessages]);

	return (
		<FormSelect
			testId="MessageSelect"
			name="selectedDropboxPushMessage"
			label="messageLabel"
			options={mappedData}
			onChange={setDropboxPushMessage}
			validationRules={validationRules}
		/>
	);
};

export default React.memo(MessageSelect);
